<div mat-dialog-title style="margin:0px;">{{ PageTitle }}</div>

    <mat-dialog-content>
        <!-- This section is the default, for creating new elements -->
        <div style="padding: 10px;" *ngIf="PageTitle === 'Create New Element'">
            {{ Message }}
            <tr>
                <td>
                    Page Name<br />
                    <mat-select id="elementsAndAreasDdlElementAreas" name="elementsAndAreasDdlElementAreas"
                    [ngModel]="distinctTestAreas"
                    aria-label="Page Name Drop Down List">
                        <mat-option *ngFor="let item of distinctTestAreas; index as i;"
                        id="elementArea{{i}}"
                        [value]="item"
                        [attr.aria-label] = "item.AreaName"
                        (click)="elemSubAreas = []; getElements(item); setElementArea(item); getSubAreas(item.AreaName)">
                            {{ item.AreaName }}
                        </mat-option>
                    </mat-select>
                </td>
                <td>
                    Tab / View<br />
                    <mat-select id="elementsAndAreasDdlElementSubAreas" name="elementsAndAreasDdlElementSubAreas"
                    [ngModel]="elemSubAreas"
                    aria-label="Tab or View Name Drop Down List">
                        <mat-option *ngFor="let item of elemSubAreas; index as i;"
                        id="elementArea{{i}}"
                        [attr.aria-label] = "item"
                        [value]="item"
                        (click)="setElementSubArea(item)">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </td>
                <td>
                    Element Name<br />
                    <input type='text' #NewElementName spellcheck="true"
                    id="txtElementsAndAreasNewElementName"
                    name="txtNewElementName"
                    aria-label="Element Name Input"
                    rows="1">
                </td>
                <td style='width:160px;'>
                    XPath<br />
                    <input type='text' #NewElementXPath spellcheck="true"
                    id="txtElementsAndAreasNewXPath"
                    name="txtNewXPath"
                    aria-label="Element XPath Input"
                    rows="1">
                </td>
                <td style='width:160px;'>
                    Control Type<br />
                    <mat-select id="elementsAndAreasDdlControlTypes" name="elementsAndAreasDdlControlTypes"
                    [ngModel]="allControlNames"
                    aria-label="Element Control Type Drop Down List">
                        <mat-option *ngFor="let item of allControlNames; index as i;"
                        id="controlType{{i}}"
                        [value]="item"
                        [attr.aria-label] = "item"
                        (click)="setElementControl(item)">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </td>
            </tr>
        </div>


        <!-- This section allows the user to update existing elements; any changes here will be applied to the previously selected element. -->
        <div style="padding: 10px;" *ngIf="PageTitle === 'Edit Element'">
            {{ Message }}
            <tr>
                <td>
                    Module | Page Name<br />
                    <mat-select id="elementsAndAreasDdlElementAreas" name="elementsAndAreasDdlElementAreas"
                    [ngModel]="elementArea"
                    placeholder="{{ elementArea }}"
                    aria-label="Module or Page Name Drop Down List">
                        <mat-option *ngFor="let item of distinctTestAreas; index as i;"
                        id="elementArea{{i}}"
                        [value]="item"
                        [attr.aria-label] = "item.AreaName"
                        (click)="getTestAreas(); elemSubAreas = []; getElements(item); setElementArea(item); getSubAreas(item.AreaName)">
                            {{ item.AreaName }}
                        </mat-option>
                    </mat-select>
                </td>
                <td>
                    Portal | Tab / View<br />
                    <mat-select id="elementsAndAreasDdlElementSubAreas" name="elementsAndAreasDdlElementSubAreas"
                    [ngModel]="elementSubArea"
                    placeholder="{{ elementSubArea }}"
                    aria-label="Portal Name or Tab / View Name Drop Down List">
                        <mat-option *ngFor="let item of elemSubAreas; index as i;"
                        id="elementSubArea{{i}}"
                        [value]="item"
                        [attr.aria-label] = "item"
                        (click)="setElementSubArea(item)">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </td>
                <td>
                    Element Name<br />
                    <input matInput type='text' #NewElementName spellcheck="true"
                    [ngModel]="elementName"
                    id="txtElementsAndAreasNewElementName"
                    name="txtElementsAndAreasNewElementName"
                    placeholder="{{ elementName }}"
                    aria-label="Element Name Input"
                    rows="1">
                </td>
                <td>
                    XPath<br />
                    <input matInput type='text' #NewElementXPath spellcheck="true"
                    [ngModel]="elementXPath"
                    id="txtElementsAndAreasNewXPath"
                    name="txtElementsAndAreasNewXPath"
                    placeholder="{{ elementXPath }}"
                    aria-label="Element XPath Input"
                    rows="1">
                </td>
                <td style='width:160px;'>
                    Control Type<br />
                    <mat-select id="ElementsAndAreasDdlControlTypes" name="elementsAndAreasDdlControlTypes"
                    [ngModel]="allControlNames"
                    placeholder="{{ elementControlName }}"
                    aria-label="Control Types Drop Down List">
                        <mat-option *ngFor="let item of allControlNames; index as i;"
                        id="elementArea{{i}}"
                        [value]="item"
                        [attr.aria-label] = "item"
                        (click)="setElementControl(item)">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </td>
            </tr>
        </div>

    </mat-dialog-content>

    <!-- Footer -->
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button id="okButton" image="Check.png" label="Save" aria-label= "Save Button" (click)="okClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Cancel" aria-label="Cancel Button" (click)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
